import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { EventSubscriberRepository, FeedType, getCommunityTopic, PostTargetType, SubscriptionLevels, } from '@amityco/js-sdk';
import { FormattedMessage } from 'react-intl';
import CommunityCreatedModal from '../../../social/components/CommunityCreatedModal';
import useCommunity from '../../../social/hooks/useCommunity';
import withSDK from '../../../core/hocs/withSDK';
import useCommunityOneMember from '../../../social/hooks/useCommunityOneMember';
import Feed from '../../../social/components/Feed';
import MediaGallery from '../../../social/components/MediaGallery';
import CommunityInfo from '../../../social/components/CommunityInfo';
import CommunityMembers from '../../../social/components/CommunityMembers';
import FeedHeaderTabs from '../../../social/components/FeedHeaderTabs';
import { CommunityFeedTabs } from './constants';
import { getTabs } from './utils';
import { DeclineBanner, Wrapper } from './styles';
import { ANONYMOUS_METADATA } from '../../../social/constants';
const ADMIN_ONLY_POST_SETTING = 'ONLY_ADMIN_CAN_POST';
const CommunityFeed = ({ communityId, currentUserId, isNewCommunity, handleCopyPostPath, handleCopyCommentPath, }) => {
    var _a, _b, _c;
    const { community } = useCommunity(communityId);
    const { canReviewCommunityPosts, hasModeratorPermissions } = useCommunityOneMember(communityId, currentUserId, community.userId);
    const isJoined = !!(community === null || community === void 0 ? void 0 : community.isJoined);
    const isAdminOnly = (community === null || community === void 0 ? void 0 : community.postSetting) === ADMIN_ONLY_POST_SETTING;
    const pendingPostCount = (_b = (_a = community.reviewingFeed) === null || _a === void 0 ? void 0 : _a.postCount) !== null && _b !== void 0 ? _b : 0;
    const canCreatePosts = isJoined && isAdminOnly ? hasModeratorPermissions : true;
    const tabs = useMemo(() => {
        var _a, _b;
        return getTabs(community === null || community === void 0 ? void 0 : community.postSetting, community === null || community === void 0 ? void 0 : community.isJoined, canReviewCommunityPosts, (_b = (_a = community === null || community === void 0 ? void 0 : community.metadata) === null || _a === void 0 ? void 0 : _a[ANONYMOUS_METADATA]) !== null && _b !== void 0 ? _b : false, pendingPostCount);
    }, [
        community === null || community === void 0 ? void 0 : community.postSetting,
        community === null || community === void 0 ? void 0 : community.isJoined,
        canReviewCommunityPosts,
        (_c = community === null || community === void 0 ? void 0 : community.metadata) === null || _c === void 0 ? void 0 : _c[ANONYMOUS_METADATA],
        pendingPostCount,
    ]);
    const [activeTab, setActiveTab] = useState(CommunityFeedTabs.TIMELINE);
    useEffect(() => {
        const topic = getCommunityTopic(community, SubscriptionLevels.POST);
        EventSubscriberRepository.subscribe(topic);
        return () => EventSubscriberRepository.unsubscribe(topic);
        // eslint-disable-next-line
    }, [community.id]);
    useEffect(() => {
        if (!tabs.find((tab) => tab.value === activeTab)) {
            setActiveTab(tabs[0].value);
        }
    }, [activeTab, tabs]);
    const [isCreatedModalOpened, setCreatedModalOpened] = useState(isNewCommunity);
    return (React.createElement(Wrapper, null,
        React.createElement(CommunityInfo, { communityId: communityId }),
        React.createElement(FeedHeaderTabs, { "data-qa-anchor": "community-feed-header", tabs: tabs, activeTab: activeTab, onChange: setActiveTab }),
        activeTab === CommunityFeedTabs.TIMELINE && (React.createElement(Feed, { targetType: PostTargetType.CommunityFeed, targetId: communityId, readonly: !isJoined, showPostCreator: canCreatePosts, feedType: FeedType.Published, handleCopyPostPath: handleCopyPostPath, handleCopyCommentPath: handleCopyCommentPath })),
        activeTab === CommunityFeedTabs.GALLERY && (React.createElement(MediaGallery, { targetType: PostTargetType.CommunityFeed, targetId: communityId })),
        activeTab === CommunityFeedTabs.MEMBERS && React.createElement(CommunityMembers, { communityId: communityId }),
        activeTab === CommunityFeedTabs.PENDING && (React.createElement(React.Fragment, null,
            canReviewCommunityPosts && (React.createElement(DeclineBanner, null,
                React.createElement(FormattedMessage, { id: "community.review.declinePendingPosts" }))),
            React.createElement(Feed, { targetType: PostTargetType.CommunityFeed, targetId: communityId, readonly: !isJoined, showPostCreator: false, feedType: FeedType.Reviewing, handleCopyPostPath: handleCopyPostPath, handleCopyCommentPath: handleCopyCommentPath }))),
        isCreatedModalOpened && (React.createElement(CommunityCreatedModal, { communityId: communityId, onClose: () => setCreatedModalOpened(false) }))));
};
CommunityFeed.propTypes = {
    communityId: PropTypes.string.isRequired,
    currentUserId: PropTypes.string.isRequired,
    isNewCommunity: PropTypes.bool,
    handleCopyPostPath: PropTypes.func,
    handleCopyCommentPath: PropTypes.func,
};
CommunityFeed.defaultProps = {
    isNewCommunity: false,
};
export default withSDK(CommunityFeed);
//# sourceMappingURL=index.js.map